import { HelpLayout } from '@layouts/help/HelpLayout'
import HelpPage from '@pages/help/HelpPage'
import { Navigate, RouteObject } from 'react-router-dom'

const helpRoutes: RouteObject[] = [
  {
    element: <HelpLayout />,
    children: [
      { index: true, element: <HelpPage /> },
      { path: '*', element: <Navigate to="/404" replace /> },
    ],
  },
]

export default helpRoutes
